import styled from 'styled-components'

export const Background = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
`

export const Layout = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2.8rem 1.2rem;

  @media screen and (min-width: 768px) {
    padding: 6rem 1.2rem;
  }
`

export const Cards = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4rem;
  width: 100%;

  @media (min-width: 992px) {
    flex-direction: row;
  }
`
